import { render, staticRenderFns } from "./cadastroGenerico.vue?vue&type=template&id=71a76984&scoped=true"
import script from "./cadastroGenerico.vue?vue&type=script&lang=js"
export * from "./cadastroGenerico.vue?vue&type=script&lang=js"
import style0 from "./cadastroGenerico.vue?vue&type=style&index=0&id=71a76984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a76984",
  null
  
)

export default component.exports